import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import HomePage from "@/pages/Home";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetail from "@/pages/ServiceDetail";
import PortfolioPage from "@/pages/PortfolioPage";
import PortfolioDetail from "@/pages/PortfolioDetail";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import AdminLogin from "@/pages/AdminLogin";
import WhatsAppButton from "@/components/WhatsAppButton";

import AdminLayout from "@/components/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminServices from "@/pages/admin/AdminServices";
import AdminPortfolios from "@/pages/admin/AdminPortfolios";
import AdminInquiries from "@/pages/admin/AdminInquiries";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/layanan" element={<ServicesPage />} />
            <Route path="/layanan/:slug" element={<ServiceDetail />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="/portfolio/:slug" element={<PortfolioDetail />} />
            <Route path="/tentang" element={<AboutPage />} />
            <Route path="/kontak" element={<ContactPage />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="portfolios" element={<AdminPortfolios />} />
              <Route path="inquiries" element={<AdminInquiries />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <WhatsAppButton />
        </BrowserRouter>
        <Toaster
          position="top-right"
          theme="light"
          toastOptions={{
            style: {
              border: "1px solid #E4E4E7",
              borderRadius: 0,
              fontFamily: "IBM Plex Sans, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
